export { default as VatReturnForm } from './vat-return-form';

export const data = {
  ct09: '',
  ct10: '',
  ct11: '',
  ct11a: '',
  ct11c: '',
  'full-name': '',
  'signer-name': '',
  'license-number': '',
  'signing-date': new Date(),
};

export const layout = {
  'div.grid.grid-cols-2': {
    'div.col-span-2': {
      slot: 'vat-info-title',
    },
    'div.col-span-2:0': { field: 'ct09' },
    'div.col-span-1': { field: 'ct10' },
    'div.col-span-2:1': { field: 'ct11' },
    'div.col-span-1.md-col-span-2:0': {
      'div:1': { field: 'ct11c' },
      'div:3': { field: 'ct11a' },
    },
    'div.col-span-2:2': {
      slot: 'default',
    },
    'div.col-span-2.grid.grid-cols-1.mt-3': {
      div: {
        slot: 'tax-agent-staff-info-title',
      },
      'div.grid.grid-cols-2.gap-x-30': {
        'div.col-span-1.md-col-span-2': { field: 'full-name' },
        'div.col-span-1.md-col-span-2:0': { field: 'signer-name' },
        'div.col-span-1.md-col-span-2:1': { field: 'license-number' },
        'div.col-span-1.md-col-span-2:2': { field: 'signing-date' },
      },
    },
  },
};

export const schema = context => ({
  ct09: {
    label: `[09] ${context.$t('vat.form.09.label')}:`,
    placeholder: '',
    type: 'input',
  },
  ct10: {
    label: `[10] ${context.$t('vat.form.10.label')}:`,
    placeholder: '',
    type: 'input',
  },
  ct11: {
    label: `[11] ${context.$t('vat.form.11.label')}:`,
    placeholder: '',
    type: 'input',
  },
  ct11c: {
    label: `[11c] ${context.$t('vat.form.11.c.label')}:`,
    placeholder: '',
    type: 'input',
  },
  ct11b: {
    label: `[11b] ${context.$t('vat.form.11.b.label')}:`,
    placeholder: '',
    type: 'input',
  },
  ct11a: {
    label: `[11a] ${context.$t('vat.form.11.a.label')}:`,
    placeholder: '',
    type: 'input',
  },
  'full-name': {
    label: context.$t('vat.form.full-name.label'),
    placeholder: '',
    type: 'input',
  },
  'signer-name': {
    label: context.$t('vat.form.signer-name.label'),
    placeholder: '',
    type: 'input',
  },
  'license-number': {
    label: context.$t('vat.form.license-number.label'),
    placeholder: '',
    type: 'input',
  },
  'signing-date': {
    label: context.$t('vat.form.signing-date.label'),
    placeholder: '',
    type: 'datepicker',
  },
});



// WEBPACK FOOTER //
// ./src/portal-components/value-added-tax/vat-return/vat-return-form/index.js